(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalTwoButtonsController', ModalTwoButtonsController);

    ModalTwoButtonsController.$inject = [
        '$modalInstance',
        '$log',
        'lodash',
        'content',
        'options'
    ];

    function ModalTwoButtonsController($modalInstance, $log, _, content, options) {
        var vm = this;

        $log.debug('ModalTwoButtonsController', vm);

        vm.onBtnPrimary = onBtnPrimary;
        vm.onBtnSecondary = onBtnSecondary;

        activate();

        function activate() {
            vm.content = content;
            vm.options = options || {};

            vm.contentBody = vm.content.body;

            vm.labelBtnPrimary = _.get(vm.options, 'labels.btnPrimary') || 'Ja';
            vm.labelBtnSecondary = _.get(vm.options, 'labels.btnSecondary') || 'Nein';
        }
        function onBtnPrimary() {
            $modalInstance.close();
        }
        function onBtnSecondary() {
            $modalInstance.dismiss('no');
        }
    }

})();
